import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { useTextField } from 'react-aria';

const DatePart = (props) => {
    const ref = useRef();
    const { inputProps, labelProps } = useTextField(props, ref); // Generate the accessability tags for the input
    return (
        <div className="govuk-date-input__item">
            <div className="govuk-form-group">
                <label { ...labelProps } className="govuk-label govuk-date-input__label">
                    { props.label }
                </label>
                <input { ...inputProps } onBlur={props.onBlur} onChange={props.onChange} className={['govuk-input', 'govuk-date-input__input', 'govuk-input--' + props.width, (props.hasError && 'govuk-input--error')].join(' ')} type="text" inputMode="numeric" value={props.value} data-testid={props['data-testid']} />
            </div>
        </div>);
};

DatePart.propTypes = {
    label: PropTypes.string,
    width: PropTypes.oneOf(['width-2', 'width-4']),
    hasError: PropTypes.bool,
    value: PropTypes.string,
    'data-testid': PropTypes.string,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    name: PropTypes.string,
    id: PropTypes.string
};

DatePart.defaultProps = {
    width: 'width-2',
    hasError: false
};

export default DatePart;
